import TextHighlighter from "./TextHighlighter";

export default TextHighlighter;
